export const GET_FILE_PENDING = 'GET_FILE_PENDING'
export const GET_FILE_SUCCESSFUL = 'GET_FILE_SUCCESSFUL'
export const GET_FILE_ERROR = 'GET_FILE_ERROR'

export const DELETE_FILE_PENDING = 'DELETE_FILE_PENDING'
export const DELETE_FILE_SUCCESSFUL = 'DELETE_FILE_SUCCESSFUL'
export const DELETE_FILE_ERROR = 'DELETE_FILE_ERROR'
